import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

type Props = {
    onActionEdit: (idChecklistAmbiente: number | null, openState: boolean) => void,
    onActionDelete: (idChecklistAmbiente: number | null, openState: boolean) => void,
    onActionCopia: (idChecklistAmbiente: number | null, openState: boolean) => void,
    onActionItens: (idChecklistAmbiente: number, openState: boolean) => void,
}

export const GenerateChecklistEntregaAmbienteColumns = ({
    onActionEdit,
    onActionDelete,
    onActionCopia,
    onActionItens,

}: Props): GridColDef[] => {
    return [
        {
            field: "ordem",
            filterable: false,
            headerName: "Ordem",
            minWidth: 100,
            width: 120,
            sortable: false,
            renderCell: ({ value }) => (
                <div className="w-full h-full flex justify-center items-center gap-2 break-normal">
                    <span>{value}</span>
                </div>
            )
        },
        {
            field: "descricao",
            filterable: false,
            headerName: "Ambiente",
            flex: 1,
            minWidth: 200,
            sortable: false,
            renderCell: ({ value }) => (
                <div className="w-full h-full flex items-center gap-2 break-normal">
                    <span>{value}</span>
                </div>
            )
        },
        {
            field: 'itens',
            sortable: false,
            filterable: false,
            headerName: 'Itens de inspeção',
            headerAlign: 'center',
            minWidth: 200,
            valueGetter: (_, row) => row['idChecklistEntregaAmbiente'] as number,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">
                        <Button
                            onMouseDown={e => {
                                if (e.button === 1) {
                                    onActionItens(params.value, true);
                                } else {
                                    onActionItens(params.value, e.ctrlKey);
                                }
                                e.preventDefault();
                            }}
                            sx={{
                                fontSize: 11,
                                paddingX: '.4rem',
                                paddingY: 0,
                                background: '#e6e6e6',
                                borderLeft: '.2rem solid #45b6af',
                                borderRadius: 0,
                                color: 'black',
                                fontWeight: 'normal',
                            }}>
                            Itens de inspeção
                        </Button>
                    </div>
                );
            }
        },
        {
            field: 'idChecklistEntregaAmbiente',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            headerAlign: 'center',
            minWidth: 180,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>

                        <IconButton onClick={() => onActionCopia(params.value, true)}>
                            <DynamicIcon nameIcon="ContentCopyRounded" size={22} className="text-purple-500 dark:text-white" />
                        </IconButton>

                    </div>
                );
            }
        }

    ];

}